import React from "react";
import Layout from "../layout/Layout";

const Historia = () => {
  return (
    <Layout>
      <div
        className="w-full m-auto"
        style={{ background: "rgb(217, 218, 217)" }}
      >
        <img className="m-auto" src="./img/historia.png" alt="" />
      </div>
    </Layout>
  );
};

export default Historia;
